import React from 'react';
import { useModal } from 'mui-modal-provider';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { FormattedMessage } from 'react-intl';
import { useStyles } from '../field.styles';

import icon from '../../../../../../assets/images/icons/arrow/chevron-bottom.svg';
import { ExperienceModal } from '../experience-modal';
import { LensesExperience } from '../../../../../../constants/profile';

export const Experience = ({ onSetValue, value }: { onSetValue: (value: LensesExperience) => void, value?: LensesExperience }): JSX.Element => {
  const { showModal } = useModal();
  const intl = useIntl();
  const classes = useStyles();

  const handleOpenModal = () => {
    showModal(ExperienceModal, { onSetValue, value });
  };
  return (
    <div className={cx(classes.wrapper, classes.medium)}>
      <h3 className={classes.title}>
        <FormattedMessage id="createKidsProfile.clExperience" />
        <span className={classes.asterisk}>*</span>
      </h3>
      {value && <span className={classes.text}>{intl.formatMessage({ id: `createKidsProfile.clExperience.${value}` })}</span>}
      <button
        type="button"
        onClick={handleOpenModal}
        className={classes.button}
        aria-label={intl.formatMessage({ id: 'common.change' })}
      >
        <img className={classes.iconSmall} src={icon} alt="" />
      </button>
    </div>
  );
};
